import { useState } from 'react'

import { useIsTextTruncated } from '@inno-tools/react-hooks'
import { ContextMenu, ContextMenuPlacements } from '@inno-ui/context-menu'
import { ChevronRightIcon, IconSizes, IconWeight } from '@inno-ui/icons'
import { Tooltip } from '@inno-ui/tooltip'
import { Link } from 'react-router-dom'

import { USER_PROFILE_Z_INDEX } from '../../UserProfile.constants'
import styles from './ProfileMenuRow.module.scss'
import type { ProfileMenuRowProps } from './ProfileMenuRow.types'

export const ProfileMenuRow = ({
  label,
  icon,
  actionLabel,
  onClick,
  href,
  contextMenuProps
}: ProfileMenuRowProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { isTruncated, textRef } = useIsTextTruncated()
  const content = (
    <>
      <span className={styles.label}>
        <span className={styles.icon}>{icon}</span>
        <Tooltip
          overlay={label}
          disabled={!isTruncated}
          maxWidth='320px'
          zIndex={USER_PROFILE_Z_INDEX.tooltip}
        >
          <span className={styles.textContainer}>
            <span ref={textRef} className={styles.truncatedLabel}>
              {label}
            </span>
          </span>
        </Tooltip>
      </span>
      {actionLabel && (
        <span className={styles.action}>
          {actionLabel}
          <ChevronRightIcon
            size={IconSizes.Size16}
            weight={IconWeight.Bold}
            color='currentColor'
          />
        </span>
      )}
    </>
  )

  if (href)
    return (
      <Link className={styles.row} to={href} onClick={onClick}>
        {content}
      </Link>
    )

  const trigger = (
    <button
      type='button'
      className={styles.row}
      onClick={onClick}
      disabled={contextMenuProps?.disabled}
      aria-expanded={contextMenuProps ? isOpen : undefined}
    >
      {content}
    </button>
  )
  if (!contextMenuProps) return trigger

  return (
    <ContextMenu
      {...contextMenuProps}
      triggerNode={trigger}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      placement={ContextMenuPlacements.BottomEnd}
      zIndex={USER_PROFILE_Z_INDEX.contextMenu}
      maxHeight='min(60dvh, 300px)'
    />
  )
}
